import {
  FETCH_FAQ,
  FETCH_FAQ_SUCCESS,
  FETCH_FAQ_FAIL,
  GET_FAQ,
  GET_FAQ_SUCCESS,
  GET_FAQ_FAIL,
  CREATE_FAQ,
  CREATE_FAQ_SUCCESS,
  CREATE_FAQ_FAIL,
  UPDATE_FAQ,
  UPDATE_FAQ_SUCCESS,
  UPDATE_FAQ_FAIL,
  DELETE_FAQ,
  DELETE_FAQ_SUCCESS,
  DELETE_FAQ_FAIL,
} from 'actions/faq';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  faqs: [],
  faqDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const faqReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_FAQ:
    case GET_FAQ:
    case CREATE_FAQ:
    case DELETE_FAQ: {
      return { ...state, isLoading: true, faqDetail: {} };
    }

    case UPDATE_FAQ: {
      return { ...state, isLoading: true };
    }

    case FETCH_FAQ_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        faqs: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case GET_FAQ_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        faqDetail: payload,
      };
    }

    case CREATE_FAQ_SUCCESS: {
      toast.success(' FAQ added successfully');
      return {
        ...state,
        isLoading: false,
        faqs: _.concat(state.faqs, payload),
      };
    }

    case UPDATE_FAQ_SUCCESS: {
      toast.success(' FAQ updated successfully');
      return {
        ...state,
        faqs: state.faqs.map((data) => (data.id === payload.id ? payload : data)),
        isLoading: false,
      };
    }

    case DELETE_FAQ_SUCCESS: {
      toast.success(' FAQ deleted successfully');
      return {
        ...state,
        isLoading: false,
        faqs: state.faqs.filter((data) => data.id !== payload),
      };
    }

    case FETCH_FAQ_FAIL:
    case GET_FAQ_FAIL:
    case CREATE_FAQ_FAIL:
    case UPDATE_FAQ_FAIL:
    case DELETE_FAQ_FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default faqReducer;
